import React from "react";
import { Box, BoxProps } from "@mui/material";

const CustomerLogo: React.FC<BoxProps> = (props) => {
  return (
    <Box component="img" src="/images/logo.svg" alt="Capio Logo" {...props} />
  );
};

export default CustomerLogo;
